import React from "react";

function PrivacyPolicy() {
  return (
    <div className="page-container">
      <h2>🔐 Privacy Policy</h2>

      <p>
        गुलशन-ए-रज़ा फाउंडेशन आपकी निजता (Privacy) का पूरा सम्मान करता है। यह Privacy
        Policy बताती है कि हम आपकी जानकारी कैसे एकत्र करते हैं, उसका उपयोग कैसे करते
        हैं और उसे सुरक्षित कैसे रखते हैं।
      </p>

      <h4>📌 हम कौन-सी जानकारी लेते हैं?</h4>
      <ul>
        <li>नाम, मोबाइल नंबर, शहर (केवल रजिस्ट्रेशन के समय)</li>
        <li>डोनेशन से जुड़ी सीमित जानकारी</li>
      </ul>

      <h4>📌 जानकारी का उपयोग</h4>
      <ul>
        <li>छात्र रजिस्ट्रेशन और संपर्क के लिए</li>
        <li>हमारी सामाजिक और शैक्षिक सेवाओं को बेहतर बनाने के लिए</li>
        <li>किसी भी प्रकार की गलत या गैरकानूनी गतिविधि से बचाव के लिए</li>
      </ul>

      <h4>📌 आपकी जानकारी की सुरक्षा</h4>
      <p>
        हम आपकी व्यक्तिगत जानकारी को किसी तीसरे पक्ष के साथ बिना अनुमति साझा नहीं
        करते। आपकी जानकारी सुरक्षित सर्वर और सीमित एक्सेस के साथ रखी जाती है।
      </p>

      <h4>📌 Third Party Links & Ads</h4>
      <p>
        हमारी वेबसाइट पर भविष्य में Google AdSense या अन्य थर्ड पार्टी लिंक हो सकते
        हैं। उनके कंटेंट और पॉलिसी के लिए हम जिम्मेदार नहीं होंगे।
      </p>

      <h4>📌 Policy Updates</h4>
      <p>
        समय-समय पर यह Privacy Policy अपडेट की जा सकती है। किसी भी बदलाव की जानकारी
        इसी पेज पर दी जाएगी।
      </p>

      <p>
        📧 यदि आपको Privacy Policy से संबंधित कोई प्रश्न हो, तो आप हमसे संपर्क कर
        सकते हैं।
      </p>
    </div>
  );
}

export default PrivacyPolicy;
